import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

export const shortenValue = (value, maxLength) => {
  if (value.length > maxLength) {
    return value.substring(0, maxLength) + '...';
  } else {
    return value;
  }
}
class EditableLabel extends React.Component {
  static defaultProps = {
    enabled: true,
  };

  static propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onCancelEdit: PropTypes.func,
    style: PropTypes.object,
    enabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      editing: false,
    };
  }

  doneEditing = (newValue) => {
    this.setState({editing: false});
    this.props.onChange(newValue);
  }

  getDisplayComponent = () => (
    <div className="editable-label_label"
         onDoubleClick={this.props.enabled ? this.startEditing : null}>
        {shortenValue(this.props.value, 15)}
    </div>
  )

  cancelEditing = () => this.setState({editing: false});

  getEditComponent = () => (
    <input type="text"
           className="editable-label_input"
           defaultValue={this.props.value}
           onBlur={this.cancelEditing}
           autoFocus
           onKeyUp={this.handleKeyUp}/>
  )

  handleKeyUp = (ev) => {
    if (ev.keyCode === 13) {
      this.doneEditing(ev.currentTarget.value);
    } else if (ev.keyCode === 27) {
      this.cancelEditing();
    }
  }

  startEditing = () => this.setState({editing: true});

  render() {
    return (
      <div className="editable-label" style={this.props.style}>
        {this.state.editing ? this.getEditComponent() : this.getDisplayComponent()}
      </div>
    );
  }
}

export default EditableLabel;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/EditableLabel/index.js